import { axiosPost } from './AxiosApi';

type ResTickerProps = {
  id: number;
  base: string;
  base_dt: string;
  latest_price: string;
  best_bid: string;
  best_ask: string;
  high24h: string | null;
  low24h: string | null;
  volume24h: string | null;
  reg_dttm: string;
  // amount: string;
  // amt: string;
  // icon: string;
  // krw: string;
  // ret_dttm: string;
  // symbol: string;
  // usdt: string;
};
type tickerProps = {
  symbol: string;
  amount?: string;
};
export const ticker = async ({
  symbol,
  amount = '1',
}: tickerProps): Promise<{ ret_code: number; msg: string; data: ResTickerProps }> => {
  const payload = {
    apiUrl: process.env.REACT_APP_API_URL,
    path: '/tickers',
    body: {
      symbol,
      amount,
    },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};
